import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'
import { encrypt } from '@/utils/rsaEncrypt'

export const adList = params => {
    return request({
        url: requestUrl('/user/searchADUser'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryUserList = params => {
    return request({
        url: requestUrl('/user/searchKpmgUser'),
        method: 'post',
        data: requestParam(params)
    })
}

export const querySysAdminUser = params => {
    return request({
        url: requestUrl('/user/searchSysAdminUser'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteUser = params => {
    return request({
        url: requestUrl('/user/delete'),
        method: 'post',
        data: requestParam(params)
    })
}

export const batchDeleteUser = params => {
    return request({
        url: requestUrl('/user/batchDelete'),
        method: 'post',
        data: requestParam(params)
    })
}

export const addUser = params => {
    return request({
        url: requestUrl('/user/add'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryAdminList = params => {
    return request({
        url: requestUrl('/user/searchSysAdmin'),
        method: 'post',
        data: requestParam(params)
    })
}

export const addAdmin = params => {
    return request({
        url: requestUrl('/user/addSysAdmin'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteAdmin = params => {
    return request({
        url: requestUrl('/user/deleteSysAdmin'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryUserListByName = params => {
    return request({
        url: requestUrl('/site/queryUserListByName'),
        method: 'post',
        data: requestParam(params)
    })
}

export const querySiteList = params => {
    return request({
        url: requestUrl('/site/querySiteList'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryMasterCodeList = params => {
    return request({
        url: requestUrl(`/site/queryAllSites/${params.masterCode}`),
        method: 'post'
    })
}

export const exportSite = params => {
    return request({
        url: requestUrl('/site/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const addSite = params => {
    return request({
        url: requestUrl('/site/addSite'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updateSite = params => {
    return request({
        url: requestUrl('/site/updateSite'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteSite = params => {
    return request({
        url: requestUrl('/site/deleteSite'),
        method: 'post',
        data: requestParam(params)
    })
}

// IBS同步
export const syncIBSInfo = params => {
    return request({
        url: requestUrl('/test/syncIbs'),
        method: 'post',
        data: requestParam(params)
    })
}

// master界面接口
export const queryMasterList = params => {
    return request({
        url: requestUrl('/sysMasterData/searchMasterData'),
        method: 'post',
        data: requestParam(params)
    })
}

export const addMaster = params => {
    return request({
        url: requestUrl('/sysMasterData/addMasterData'),
        method: 'post',
        data: requestParam(params)
    })
}

export const editMaster = params => {
    return request({
        url: requestUrl('/sysMasterData/updateMasterData'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteMaster = params => {
    return request({
        url: requestUrl('/sysMasterData/deleteMasterData'),
        method: 'post',
        data: requestParam(params)
    })
}

// aduit trail 界面接口
export const queryAuditTrail = params => {
    return request({
        url: requestUrl('/kccAuditTrialLog/searchAuditTrial'),
        method: 'post',
        data: encrypt(requestParam(params))
    })
}

/**
 * downloadKPMGUserTemplate
 * @param {*} s
 */
export const downloadMatterFiles = params => {
    return request({
        url: requestUrl('/user/downloadKPMGUserTemplate'),
        method: 'get',
        data: requestParam(params),
        responseType: 'blob'
    })
}

/**
 * importKPMGUserTemplate
 * @param {*} s
 */
export const importKPMGUserTemplate = params => {
    return request({
        url: requestUrl('/user/import'),
        method: 'post',
        data: params,
        timeout: 3000,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * downloadSiteTemplate
 * @param {*} s
 */
export const downloadSiteTemplate = params => {
    return request({
        url: requestUrl('/site/downloadSiteTemplate'),
        method: 'get',
        data: requestParam(params),
        responseType: 'blob'
    })
}

/**
 * importKPMGUserTemplate
 * @param {*} s
 */
export const queryImport = params => {
    return request({
        url: requestUrl('/site/queryImport'),
        method: 'post',
        data: params,
        responseType: 'blob'
    })
}
export const importSiteTemplate = params => {
    return request({
        url: requestUrl('/site/import'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export const exportAduitTrail = params => {
    return request({
        url: requestUrl('/kccAuditTrialLog/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const queryAllSites = params => {
    return request({
        url: requestUrl('/client/site/queryDropDownSites'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryQRMList = params => {
    return request({
        url: requestUrl('/user/searchQRMAdmin'),
        method: 'post',
        data: requestParam(params)
    })
}

export const addQRM = params => {
    return request({
        url: requestUrl('/user/addQRMAdmin'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteQRMAdmin = params => {
    return request({
        url: requestUrl('/user/deleteQRMAdmin'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryQrmUserList = params => {
    return request({
        url: requestUrl('/user/searchQRMUser'),
        method: 'post',
        data: requestParam(params)
    })
}

// kcc 新闻管理

//kcc news
export const newsImportFile = (params, newsType) => {
    return request({
        url: requestUrl(`/kccNews/importFile?newsType=${newsType}`),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export const newsImportImg = params => {
    return request({
        url: requestUrl('/kccNews/importImage'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export const queryNewsPageInfo = params => {
    return request({
        url: requestUrl('/kccNews/pageInfo'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryNewsPublish = newsType => {
    return request({
        url: requestUrl(`/kccNews/publish?newsType=${newsType}`),
        method: 'post',
        data: requestParam()
    })
}
export const saveNewsPageInfo = params => {
    return request({
        url: requestUrl('/kccNews/save'),
        method: 'post',
        data: requestParam(params),
    })
}
export const updateNewsPageInfo = params => {
    return request({
        url: requestUrl('/kccNews/update'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryKccNews = newsType => {
    return request({
        url: requestUrl(`/kccNews/queryKccNews?newsType=${newsType}`),
        method: 'post',
        data: requestParam()
    })
}

export const deleteKccNew = params => {
    return request({
        url: requestUrl('/kccNews/delete'),
        method: 'post',
        data: requestParam(params)
    })
}






export const documentsImportFile = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/importFile'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}
export const queryDocumentsPageInfo = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/pageInfo'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryDocumentsPublish = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/publish'),
        method: 'post',
        data: requestParam(params)
    })
}
export const saveDocumentsPageInfo = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/save'),
        method: 'post',
        data: requestParam(params)
    })
}
export const updateDocumentsPageInfo = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/update'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryKccUsefulDocuments = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/queryKccUsefulDocuments'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteKccUsefulDocument = params => {
    return request({
        url: requestUrl('/kccUsefulDocuments/delete'),
        method: 'post',
        data: requestParam(params)
    })
}

export const materialsImportFile = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/importFile'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export const queryMaterialsPageInfo = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/pageInfo'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryMaterialsPublish = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/publish'),
        method: 'post',
        data: requestParam(params)
    })
}

export const saveMaterialsPageInfo = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/save'),
        method: 'post',
        data: requestParam(params)
    })
}
export const updateMaterialsPageInfo = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/update'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryKccTrainingMaterials = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/queryKccTrainingMaterials'),
        method: 'post',
        data: requestParam(params)
    })
}

export const materialsImportImage = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/importImage'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export const deleteKccTrainingMaterial = params => {
    return request({
        url: requestUrl('/kccTrainingMaterials/delete'),
        method: 'post',
        data: requestParam(params)
    })
}


